<template>
    <div class="main cycleitem">
        <my-cycle-card :course="cardInfo" :key="cardInfo.id" :type="type"></my-cycle-card>
        <div class="model-box mtm bcw">
            <div class="model-box__hd">
                <h3 class="left fs2">预约记录</h3>
            </div>
            <div class="model-box__bd fs2 c6 mtm clear">
                <appointment-card v-for="item in list" :key="item.id" :item="item"></appointment-card>                
            </div>
        </div>
        <div class="clear bcw buybar">
          <div class="buybar__content clear">
            <!-- <van-button type="default" size="normal" class="buybar__btn left fs3">申请退款</van-button> -->
            <router-link :to="{name: 'courseappointment',params: {orderId:cardInfo.orderId, itemId:cardInfo.productId, coachId:'-1', type:'clubPracticeCard'}}" class="right">
                <van-button type="primary" size="normal" class="fs3">预约练球</van-button>
            </router-link>
          </div>
        </div>
    </div>    
</template>
<script>
import Vue from 'vue';
import { Button } from 'vant';
import MyCycleCard from '@/components/MyCycleCard';
import AppointmentCard from '@/components/AppointmentCard';
Vue.use(Button);

export default {
    name: 'MyCardItem',
    components: {
        MyCycleCard,AppointmentCard
    },
    data(){
      return {
        cardInfo:{}, //卡信息
        list:{},//约课列表
        type:"DAYS_CARD",
      }
    },
    created(){
        // 取我的练球卡数据
        let _this = this;  //?为什么直接用this会报错？？
        this.$http.get('/product/getUserDaysCardInfo?id=' + this.$route.params.courseId).then(function(res){
            _this.cardInfo = res.data.value.cardInfo
            _this.list = res.data.value.reserveList
        })
    }

}
</script>
<style lang="less" scoped>
.cycleitem{
    margin: 0 .15rem;
}
.appointment-card{ 
    position: relative;
    height: .8rem;
    padding:.1rem; 
    font-size: .16rem; 
    background-color: #fff; 
    border-bottom: 1px solid #ccc; 
    color: #444;
    z-index: 1;
    &-body{
        z-index: 1;
        &__status{
            &--success{ 
                color: #68c864;
            }
        }
    }
    &-footer{
        position: absolute;
        
    }
}
.model-box{
    &__hd{
        margin: -0.05rem 0 0 -0.15rem;
        display: inline-block;
        padding: .05rem .1rem;
        background: #c3c3c3;
        color: #fff;
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
    }
}

.buybar{
    // height: .65rem;
    &__btn{
        width: 40%;
    }
}
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MyCardItem.vue